import { BillingGroupModelType } from '@teinor/erp/types/company/config/billingGroup'
import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import BaseScreenTable from '../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { ColumnTableSchema } from '../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { CustomRenderBoolean, EditRow } from '../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { permissionCheck } from '../../../../../baseComponents/PermissionChecker/function'
import ModalCEConfigBillingGroup from './ModalCEConfigBillingGroup'
import TwinTable from '../../../../../baseComponents/TwinTable'
import TwinTrans from '../../../../../baseComponents/TwinTrans'
import { useNavigate } from 'react-router'
import locations from '../../../../../utils/globals/locations'



interface ConfigBillingGroupsProps extends ComponentWithPermissions { }

const ConfigBillingGroups: React.FC<ConfigBillingGroupsProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('billingGroups', 'Grupos de Facturación'),
        newText: t('newBillingGroup', 'Nuevo Grupo de Facturación'),
    }

    return (
        <BaseScreenTable TableComponent={TableBillingGroups} CreateModalComponent={ModalCEConfigBillingGroup} EditModalComponent={ModalCEConfigBillingGroup} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableBillingGroupsProps extends TableComponentProps {}

const TableBillingGroups: React.FC<TableBillingGroupsProps> = ({ userPermissions, setTableInstance, setOpened }) => {
    const { t } = useTwinTranslation()
    const navigate = useNavigate()

    const columns: ColumnTableSchema<BillingGroupModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'is_default',
            dataKey: 'is_default',
            label: t('byDefault', 'Por defecto'),
            customRender: (value: any) => <CustomRenderBoolean value={value} />,
            width: 90,
        },
        {
            id: 'editBillingTypesBuy',
            dataKey: 'id',
            label: '',
            customRender: (parameterValue) => <span className='cursor-pointer underline hover:text-green-43' onClick={() => navigate(locations.configBillingGroups + '/billingTypeBuy/' + parameterValue + '/main')}><TwinTrans transKey='editBillingTypesBuy'>Editar Tipos de Facturación Compras</TwinTrans></span>,
        },
        {
            id: 'editBillingTypesSell',
            dataKey: 'id',
            label: '',
            customRender: (parameterValue) => <span className='cursor-pointer underline hover:text-green-43' onClick={() => navigate(locations.configBillingGroups + '/billingTypeSell/' + parameterValue + '/main')}><TwinTrans transKey='editBillingTypesSell'>Editar Tipos de Facturación Ventas</TwinTrans></span>,
        },
        {
            id: 'editBillingRetentions',
            dataKey: 'id',
            label: '',
            customRender: (parameterValue) => <span className='cursor-pointer underline hover:text-green-43' onClick={() => navigate(locations.configBillingGroups + '/billingRetention/' + parameterValue)}><TwinTrans transKey='editTypeRetentions'>Editar Tipos de Retenciones</TwinTrans></span>,
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'update')
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'update')
        },
    ]
    return (
        <TwinTable name='billingGroups' columns={columns} getDataFrom='/api/app/config/billingGroup/getAllBillingGroups' setTableInstance={setTableInstance} defaultOrder={{ defaultOrderField: 'id', order: 'asc' }} />
    )
}


export default ConfigBillingGroups